import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { PoliticianService } from '../../services/politician.service';
import { ToastComponent } from '../../shared/toast/toast.component';
import { Politician } from '../../shared/models/politician.model';
import { profilePics } from '../../shared/constants';
import { addPaddingToSenatoId } from '../../shared/functions';
import { ee } from '../../shared/constants';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-stakeholder',
  templateUrl: './stakeholder.component.html',
  styleUrls: ['./stakeholder.component.scss'],
  standalone: false
})
export class StakeholderComponent implements OnInit {
  toast = inject(ToastComponent);
  private router = inject(Router);
  private politicianService = inject(PoliticianService);


  @Input() politician: Politician;

  isDetailsPage = false;
  commission2role = {};
  profilePics = profilePics;
  addPaddingToSenatoId = addPaddingToSenatoId;

  ngOnInit(): void {
    if (!this.politician) {
      this.toast.setMessage('This stakeholder does not exists!', 'danger');
      this.router.navigate(['/stakeholders']);
      return;
    }
    if (this.router.url.includes('stakeholder/')) {
      this.isDetailsPage = true;
    }
    if (this.politician._commissions?.length) {
      this.setCommission2role();
    }
  }

  setCommission2role() {
    for (const commission of this.politician._commissions) {
      const isChair = commission._chairs.some(_id => _id === this.politician._id) ? 'President' : '';
      const isViceChair = commission._vicechairs.some(_id => _id === this.politician._id) ? 'Vicepresident' : '';
      const isSecretary = commission._secretaries.some(_id => _id === this.politician._id) ? 'Secretary' : '';
      const isMember = commission._members.some(_id => _id === this.politician._id) ? 'Member' : '';
      this.commission2role[commission._id] = isChair || isViceChair || isSecretary || isMember;
    }
  }

  updatePolitician(field: string): void {
    ee.emit('updatePolitician', field);
  }

  deletePolitician(politician: Politician): void {
    if (window.confirm(`Are you sure you want to delete ${politician.firstName} ${politician.lastName}?`)) {
      this.politicianService.delete(politician)
        .pipe(finalize(() => this.router.navigate(['/stakeholders'])))
        .subscribe({
          next: res => this.toast.setMessage('Stakeholder deleted successfully.', 'success'),
          error: err => this.toast.setMessage(err.error.message, 'danger')
        });
    }
  }

}
